export function refactorDate (date) {
    let newDate = new Date(date)
    return (newDate.getDate().toString().padStart(2,'0'))+'/'+(newDate.getMonth()+1).toString().padStart(2,'0')+'/'+newDate.getFullYear()
}
export function refactorDateUs (date) {
    let newDate = new Date(date)
    return ((newDate.getMonth()+1).toString().padStart(2,'0')+'/'+newDate.getDate().toString().padStart(2,'0'))+'/'+newDate.getFullYear()
}